import type React from "react";
import { cn } from "@/lib/utils";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	message?: string;
	messageStyle?: string;
	otherProps?: React.HTMLAttributes<HTMLDivElement>;
}

export const ErrorMessage: React.FC<Props> = ({
	message = "",
	otherProps,
	className,
	messageStyle = "",
}) => (
	<div
		className={cn(`h-4 ${className}`)}
		role="alert"
		aria-live="polite"
		{...otherProps}
	>
		<p className={cn(`text-red-500 ${messageStyle}`)}>{message}</p>
	</div>
);
